import { useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viBlf, viCheck, viSpinnerThird } from "@sippy-platform/valkyrie";

import { ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function AddLineKeyTemplate({ lineKeyTemplate, user, lineKeyTemplateAccount, closeDrawer, dispatch }) {
  const [pending, setPending] = useState(false);

  const addLineKeyTemplate = async (lineKeyTemplate) => {
    setPending(true);

    const newLineKeyTemplate = {
      accountId: user.id,
      position: lineKeyTemplateAccount.position,
      templateId: lineKeyTemplate.id,
      id: lineKeyTemplateAccount?.id,
    };

    if (lineKeyTemplateAccount.id) {
      Promise.resolve(Api.putLineKeyTemplateAccount(newLineKeyTemplate))
        .then(() => {
          Promise.resolve(Api.getLineKeyTemplate(lineKeyTemplate)).then((_response) => {
            dispatch({
              type: "updateLineKeyTemplateAccount",
              lineKeyTemplateAccount: {
                id: lineKeyTemplateAccount.id,
                position: lineKeyTemplateAccount.position,
                template: _response.data.lineKeyTemplate,
              },
            });

            closeDrawer();
          });
        })
        .finally(() => setPending(false));
    } else {
      Promise.resolve(Api.postLineKeyTemplateAccount(newLineKeyTemplate))
        .then((response) => {
          Promise.resolve(Api.getLineKeyTemplate(lineKeyTemplate)).then((_response) => {
            dispatch({
              type: "addLineKeyTemplateAccount",
              lineKeyTemplateAccount: {
                ...newLineKeyTemplate,
                id: response.data.lineKeyTemplateAccount.id,
                template: _response.data.lineKeyTemplate,
              },
            });

            closeDrawer();
          });
        })
        .finally(() => setPending(false));
    }
  };

  return (
    <ListItem disablePadding sx={{ minHeight: 44 }}>
      <ListItemButton
        key={lineKeyTemplate.id}
        onClick={() => addLineKeyTemplate(lineKeyTemplate)}
        disabled={pending}
        sx={{ minHeight: 44 }}
      >
        <ListItemAvatar>
          <Avatar text={lineKeyTemplate.name} px={24} icon={viBlf} />
        </ListItemAvatar>
        <ListItemText primary={lineKeyTemplate.name} />
        {((lineKeyTemplateAccount?.template?.id === lineKeyTemplate.id && !pending) || pending) && (
          <ListItemIcon sx={{ minWidth: 16 }}>
            <Valkyrie icon={pending ? viSpinnerThird : viCheck} spin={pending} />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
}

AddLineKeyTemplate.propTypes = {
  lineKeyTemplateAccount: PropTypes.object,
  lineKeyTemplate: PropTypes.object,
  dispatch: PropTypes.func,
  user: PropTypes.object,
  highestPosition: PropTypes.number,
  closeDrawer: PropTypes.func,
};

export default AddLineKeyTemplate;
